import { render, staticRenderFns } from "./MalattieInfettiveView.vue?vue&type=template&id=671d3166"
import script from "./MalattieInfettiveView.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports